import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const words = ["FASTER", "BETTER", "BIGGER"];
const LETTER_DELAY = 180; // gap between letters
const WORD_PAUSE = 2000; // pause after full word

export default function Banner() {
    const [wordIndex, setWordIndex] = useState(0);
    const [activeLetter, setActiveLetter] = useState(0);

    const currentWord = words[wordIndex];

    useEffect(() => {
        let letterTimeout;

    // Animate letters one by one
    if (activeLetter < currentWord.length - 1) {
      letterTimeout = setTimeout(() => {
        setActiveLetter((prev) => prev + 1);
      }, LETTER_DELAY);
    }
    // After last letter → pause → change word
    else {
      letterTimeout = setTimeout(() => {
        setActiveLetter(-1);
        setWordIndex((prev) => (prev + 1) % words.length);
      }, WORD_PAUSE);
    }

    return () => clearTimeout(letterTimeout);
  }, [activeLetter, currentWord.length]);
    return (
        <section
            className="banner py-11 position-relative rounded3 rounded-top-0"
        >
            <div className="overlay rounded3 rounded-top-0"></div>

            <div className="container mt-10 position-relative">
                <div className="banner-inner py-11 w-lg-80 m-auto text-center text-white">

                    <div className="section-title mb-2">
                        <h6 className="text-white text-uppercase mb-2 fw-medium">
                            Convenient Solutions For Smart And Sustainable Electric Car Charging
                        </h6>

                        <h1 style={{ fontSize: "55px" }} className="text-white fw-bolder">
                            Smarter Chargers For Your Electric Vehicle{" "}
                            <span className="green text-uppercase spin-container">
                                {currentWord.split("").map((letter, index) => (
                                    <span
                                        key={index}
                                        className={`spin-letter ${index === activeLetter ? "active" : ""
                                            }`}
                                    >
                                        {letter}
                                    </span>
                                ))}
                            </span>
                        </h1>
                    </div>

                    <div className="section-body pb-8 ">
                        <p className="mb-5 ">
                            Denial Enterprise delivers high-efficiency charging infrastructure designed to keep you on the move. We bridge the gap between advanced technology and everyday convenience to provide a seamless charging experience for every EV driver.
                        </p>

                        <ul className="list-unstyled banner-btn d-md-flex justify-content-center">
                            <li className="mx-1 my-2  ">
                                <Link to="/about" className=" btn1 text-decoration-none ">Get Started</Link>
                            </li>
                            <li className="mx-1 my-2">
                                <Link to="/contact" className=" btn1 bg-white text-decoration-none text-dark">Contact Us</Link>
                            </li>
                        </ul>
                    </div>

                </div>
            </div>
        </section>
    );
}


